import crel from 'crel'

window.addEventListener('load', function() {
    if (checkCookie("analiticni") != true) return
    const s = document.createElement('script')
    s.id = 'hs-script-loader'
    s.src = '//js-eu1.hs-scripts.com/25280231.js'
    document.head.appendChild(s)
})